/**
 * 适配器组件的类型判断集合
 */
import { log } from '.';
import { FieldType, FilterOpt } from '../model';

export const isSelectComponent = (
  filterOptExtension?: FilterOpt | undefined
) => {
  if (
    filterOptExtension?.kind === FieldType.select ||
    filterOptExtension?.kind === FieldType.select_multiple ||
    filterOptExtension?.kind === FieldType.advanced_select ||
    filterOptExtension?.kind === FieldType.advanced_select_multiple ||
    filterOptExtension?.kind === FieldType.select_group ||
    filterOptExtension?.kind === FieldType.tree_select
  ) {
    return filterOptExtension;
  }
  log.error('Non selector component, not available as a filter');
  return false;
};

export const isRadioComponent = (
  filterOptExtension?: FilterOpt | undefined
) => {
  if (filterOptExtension?.kind === FieldType.radio) {
    return filterOptExtension;
  }
  log.error('Non radio component, not available as a filter');
  return false;
};

export const isSwitchComponent = (
  filterOptExtension?: FilterOpt | undefined
) => {
  if (filterOptExtension?.kind === FieldType.switch) {
    return filterOptExtension;
  }
  log.error('Non switch component, not available as a filter');
  return false;
};

export const isCheckboxComponent = (
  filterOptExtension?: FilterOpt | undefined
) => {
  if (filterOptExtension?.kind === FieldType.checkbox) {
    return filterOptExtension;
  }
  log.error('Non checkbox component, not available as a filter');
  return false;
};

export const isDateComponent = (filterOptExtension?: FilterOpt | undefined) => {
  if (
    filterOptExtension?.kind === FieldType.date ||
    filterOptExtension?.kind === FieldType.date_range
  ) {
    return filterOptExtension;
  }
  log.error('Non date component, not available as a filter');
  return false;
};

export const isMultiDateComponent = (
  filterOptExtension?: FilterOpt | undefined
) => {
  if (filterOptExtension?.kind === FieldType.date_multiple) {
    return filterOptExtension;
  }
  log.error('Non date component, not available as a filter');
  return false;
};

export const isSelectUserComponent = (
  filterOptExtension?: FilterOpt | undefined
) => {
  if (
    filterOptExtension?.kind === FieldType.user_chooser ||
    filterOptExtension?.kind === FieldType.user_chooser_multiple
  ) {
    return filterOptExtension;
  }
  log.error('Non selector user component, not available as a filter');
  return false;
};

export const isCascaderMultiComponent = (
  filterOptExtension?: FilterOpt | undefined
) => {
  if (filterOptExtension?.kind === FieldType.cascader_multiple) {
    return filterOptExtension;
  }
  log.error('Non cascader component, not available as a filter');
  return false;
};
